import util from "./_util";

const { request } = util;

export default {
  //查询待认领心愿
  queryWaitConfirmWishlist() {
    return request.get("/wish_claim/pager_wait_confirm_wishlist");
  },
  //认领心愿（党员和单位）
  claimWish(data) {
    return request.post("/wish_claim/claim", data);
  },
  //放弃认领心愿
  giveupClaimWish(data) {
    return request.post("/wish_claim/giveup", data);
  },
  //分页查询党员或单位的认领心愿列表
  queryClaimWishList(data) {
    return request.get("/wish_claim/pager_claim_wish", data);
  },
  //更新进度
  updateProcess(data) {
    return request.post("/wish_claim/update_process", data);
  },
  //查询某个心愿中某个党员或机构的进度
  queryProcess(data) {
    return request.post("/wish_claim/get_process", data);
  },
  //删除某个进度
  deleteProcess(data) {
    return request.post("/wish_claim/delete_process", data);
  },
};
